import axios from 'axios';

import runtimeConfig from '@/common/runtime-config';

import authMock from './authMock';

const oidcAxios = axios.create({
  baseURL: runtimeConfig.apiAuthUrl,
  withCredentials: true,
});

const authApi = {
  exchange(payload) {
    return oidcAxios.post('api/auth/exchange', payload);
  },

  refresh() {
    return oidcAxios.post('/api/auth/refresh', null, {
      params: { clientId: runtimeConfig.oidc.clientId },
    });
  },
};

export default runtimeConfig.authUseMock ? authMock : authApi;
